import React from 'react';
import PropTypes from 'prop-types';
import Utility from '../../../../../../util/utilityfunctions';

function ControlCountLabel({controlIds, controlTypeId, controlsSlice, className}) {
	let countedControls = {};

	const countControls = () => {
		let count = 0;

		if (controlIds && controlIds.length > 0) {
			controlIds.map((id) => {
				let ctrl = controlsSlice.byId[id];

				if (ctrl && ctrl.controlTypeId === controlTypeId && !countedControls[id]) {
					count++;
					countedControls[id] = true;
				}
			});
		}

		return count;
	};

	let count = countControls();

	return <span className={className}>{Utility.showISA315Counter(count)}</span>;
}

ControlCountLabel.propTypes = {
	controls: PropTypes.arrayOf(
		PropTypes.shape({
			controlTypeId: PropTypes.number
		})
	),
	controlTypeId: PropTypes.number,
	className: PropTypes.string
};

ControlCountLabel.defaultProps = {
	className: 'control-count-label'
};

export default ControlCountLabel;
